import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Function } from 'src/app/models/centrex/function';
import { OrganizationsService } from '../organizations.service';
import { ServiceBase } from '../service-base';

@Injectable({
	providedIn: 'root',
})
export class FunctionService extends ServiceBase {
	constructor(private http: HttpClient, private organizationsServices: OrganizationsService) {
		super();
	}

	getFunctions(): Observable<Function[]> {
		const httpOptions = {
			headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
		};

		return this.http.get<Function[]>(`${this.baseUrl}/api/functions`, httpOptions);
	}
}
